import {
  BottomSheet,
  PageHeaderWrapper,
  type UseModalState,
} from "@clipboard-health/ui-components";

import { PageHeaderTopRow } from "../../components/PageHeaderTopRow";
import { useInHomeCaseHistoryDataContext } from "../../ShiftDiscovery/useInHomeCaseHistoryDataContext";
import { VisitOccurrencesContent } from "./Content";
import { VisitOccurrencesListSkeleton } from "./Skeleton";

interface VisitOccurrencesBottomSheetProps {
  modalState: UseModalState;
}

export function VisitOccurrencesBottomSheet(props: VisitOccurrencesBottomSheetProps) {
  const { modalState } = props;
  const { visitOccurrences, caseData, isVisitLoading } = useInHomeCaseHistoryDataContext();

  return (
    <BottomSheet modalState={modalState} paperSx={{ height: "100%" }}>
      <PageHeaderWrapper variant="tertiary">
        <PageHeaderTopRow title="Past Visit" />
      </PageHeaderWrapper>
      {isVisitLoading ? (
        <VisitOccurrencesListSkeleton />
      ) : (
        <VisitOccurrencesContent
          patient={caseData?.attributes.patient}
          visitOccurrences={visitOccurrences}
        />
      )}
    </BottomSheet>
  );
}
